// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main-dashboard-container {
  display: flex;
  flex-direction: row-reverse;
}
.LeftSideBar {
  position: absolute;
  left: 0;
}
.Dashboard_Main_Containerxx {
  padding: 0px 24px !important;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.RightSideBar {
  position: absolute;
  right: 0;
  width: calc(100% - 280px);
}
.date-btn {
  width: 128px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 8px;
  border: 1px solid #d5dce1;
  background: #fff;
  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
  color: #405261;

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 128.571% */
}
.selectdate-container {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  align-items: center;
  margin-bottom: 41px;
}
.datepicket-container {
  display: flex;
  gap: 8px;
}
.state-text {
  color: #061522;

  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px; /* 75% */
}
.main-chart-container01 {
  display: flex;
  justify-content: center;
}
.main-chart-container01 canvas {
  width: 100% !important;
}
.ChatEmail-Container01 {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}
.Knwoledge-Main-Container {
  display: flex;
  gap: 8px;
  margin-top: 24px;
}
/* .datatable-container{
    border-radius: 8px;
border: 1px solid #E5E9EC;
background: #FFF;
} */
.Main_dashboard {
  padding: 0px 24px;
}

.Knowledge-row {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
}

.Table-Container {
  margin: 24px 0px;
}

.Dashboard-Loader-Main {
  display: flex;
  justify-content: center;
  align-items: center;
}

.overview-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.date-range-dropdown select {
  border: 1px solid #d5dce1;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  color: #405261;
  background-color: #fff;
  box-shadow: 0px 1px 2px rgba(6, 21, 34, 0.05);
  cursor: pointer;
}

.date-range-dropdown select:focus {
  outline: none;
  border-color: #66afe9;
  box-shadow: 0 0 5px rgba(102, 175, 233, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/pages/Analytics/Overview/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,OAAO;AACT;AACA;EACE,4BAA4B;EAC5B,WAAW;EACX,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,iDAAiD;EACjD,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,cAAc;;EAEd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,QAAQ;AAC7B;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;AACA;;;;GAIG;AACH;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C","sourcesContent":[".Main-dashboard-container {\n  display: flex;\n  flex-direction: row-reverse;\n}\n.LeftSideBar {\n  position: absolute;\n  left: 0;\n}\n.Dashboard_Main_Containerxx {\n  padding: 0px 24px !important;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n.RightSideBar {\n  position: absolute;\n  right: 0;\n  width: calc(100% - 280px);\n}\n.date-btn {\n  width: 128px;\n  height: 40px;\n  flex-shrink: 0;\n  border-radius: 8px;\n  border: 1px solid #d5dce1;\n  background: #fff;\n  box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\n  color: #405261;\n\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 128.571% */\n}\n.selectdate-container {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n  align-items: center;\n  margin-bottom: 41px;\n}\n.datepicket-container {\n  display: flex;\n  gap: 8px;\n}\n.state-text {\n  color: #061522;\n\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px; /* 75% */\n}\n.main-chart-container01 {\n  display: flex;\n  justify-content: center;\n}\n.main-chart-container01 canvas {\n  width: 100% !important;\n}\n.ChatEmail-Container01 {\n  display: flex;\n  gap: 8px;\n  margin-top: 24px;\n}\n.Knwoledge-Main-Container {\n  display: flex;\n  gap: 8px;\n  margin-top: 24px;\n}\n/* .datatable-container{\n    border-radius: 8px;\nborder: 1px solid #E5E9EC;\nbackground: #FFF;\n} */\n.Main_dashboard {\n  padding: 0px 24px;\n}\n\n.Knowledge-row {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 16px;\n}\n\n.Table-Container {\n  margin: 24px 0px;\n}\n\n.Dashboard-Loader-Main {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.overview-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.date-range-dropdown select {\n  border: 1px solid #d5dce1;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #405261;\n  background-color: #fff;\n  box-shadow: 0px 1px 2px rgba(6, 21, 34, 0.05);\n  cursor: pointer;\n}\n\n.date-range-dropdown select:focus {\n  outline: none;\n  border-color: #66afe9;\n  box-shadow: 0 0 5px rgba(102, 175, 233, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
